import { FC } from "react";
import { useDispatch } from "react-redux";

import type { AppDispatch } from "store";
import { clearDrawingTools } from "../model";

import styles from "./styles/SelectDrawingTool.module.css";

interface Props {
  count: number;
}

export const DeleteAllButton: FC<Props> = ({ count }) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <button
      className={styles.deleteAll}
      onClick={() => dispatch(clearDrawingTools())}
    >
      Delete all ({count})
    </button>
  );
};
